import React, { useEffect, useState } from 'react';
import { Hidden } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmEpiApiState, TcsmStates } from '../../../../root/tcsm-model';
import { getEmployments } from '../../../../global/ducks/benadmin-api';
import { SideBarContent } from '../../../../global/components/layout/sidebar-content';
import { GuidedProcessSupportBlock } from '../../../../global/components/guided-process-support-block';
import { useGpsType } from '../../../../global/hooks/useGpsType';
import { GpsType } from '../../../../global/components/layout/layout-models';
import { PageHeader } from '../../../../global/components/layout/page-header';
import { genericAccordionStyles } from '../../../../global/constants/theme/styles/components/generic-mui-accordion';
import { CompensationProps, EmploymentProps } from '../../../arc/models/arc-epi-props';
import { MyCpgPodsSettings } from '../../../mycpg-pods/mycpg-pod-models';
import { EmploymentCompensationItem } from '../../../arc/features/employment-compensation/employment-compensation-item';
import { EmploymentCompensation } from '../../../arc/features/employment-compensation/employment-compensation-models';
import { Employment } from '../../../arc/features/employment/employment-model';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { getTcsmEpiProps, setCompensationSettings, setEmploymentSettings, setPodsSettings } from '../../../../global/ducks/epi-api';
import { TcsmAppConfigs } from '../../../../global/models/configuration-models';

interface Props {
	appConfig: TcsmAppConfigs;
}

export function EmploymentHistory(props: Props) {

	const personGuid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);
	const dispatch = useDispatch();
	const gpsItem = useGpsType(GpsType.EMPLOYMENT_HISTORY);
	const myCpgSettings = useSelector<TcsmStates, MyCpgPodsSettings>(state => state.epiProps?.podsSettingsState?.epiContent);
	const epiProps = useSelector<TcsmStates, EmploymentProps>(state => state?.epiProps?.employmentSettingsState?.epiContent);
	const compProps = useSelector<TcsmStates, CompensationProps>(state => state?.epiProps?.compensationSettingsState?.epiContent);
	const labelProps = useSelector<TcsmStates, LabelSettingProps>(state => state?.epiProps?.labelSettingState?.epiContent);
	const epiApiState = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);

	const accordionClasses = genericAccordionStyles();

	const initialEmployments: Employment[] = [];

	const [employments, setEmployments] = useState(initialEmployments);

	useEffect(() => {
		if (personGuid) {
			dispatch(getEmployments(
				personGuid,
				(response) => setEmployments(response?.data),
			));
		}

		if (!epiApiState?.compensationSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, props?.appConfig?.compensationSettingsId, { personGuid }, language, false, setCompensationSettings));
		}

		if (!epiApiState?.employmentSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, props?.appConfig?.employmentSettingsId, { personGuid }, language, false, setEmploymentSettings));
		}

		if (!epiApiState?.podsSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, props?.appConfig?.podsSettingsId, { personGuid }, language, false, setPodsSettings));
		}
	}, [personGuid]);

	function EmploymentItemView(employment: Employment) {
		const employmentCompensation: EmploymentCompensation = {
			employment,
			compensations: undefined,
		};

        return (<>            
            <EmploymentCompensationItem
                key={employment?.id}
                settings={epiProps}
                compensationSettings={compProps}
                data={ employmentCompensation }
                labelSettings={labelProps}
                isMycpg
                isLatestEmployent={false}
            />
        </>);
    }
    
    if (!employments) return null;

	return (
		<>
			<PageHeader
				headerText={myCpgSettings?.employmentHistoryTitle}
				description={myCpgSettings?.employmentHistoryDescription} />
			<Hidden mdUp>
				<SideBarContent>
					<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
				</SideBarContent>
			</Hidden>
			<div className={accordionClasses.accordionContainer}>
				{
					employments?.map(employment => EmploymentItemView(employment))
				}
			</div>

		</>
	);
}